module.exports = __webpack_public_path__ + "img/ocean.c9d741a1.jpg";